import axios from "../axios";
import { IBasePlan } from "../models";
import {
  ICompanyRegisterForm,
  IGenericResponse,
  IPasswordRegisterForm,
  IRegisterValidationResponse,
  IUserRegisterForm
} from "../types/forms";

const postResendEmail = (email: string, type: string) =>
  axios.post<IGenericResponse>(`/register/email/send/${type}`, { email });
const postRegisterPassword = (data: IPasswordRegisterForm) =>
  axios.post<IGenericResponse>("/register/recover-password", data);
const postPasswordRecovery = (email: string, type: string) =>
  axios.post<IGenericResponse>(`/register/email/send/${type}`, { email });
const postRegisterUser = (data: IUserRegisterForm) =>
  axios.post<IGenericResponse>("/register/user", data);
const postRegisterCompany = (data: ICompanyRegisterForm) =>
  axios.post<IGenericResponse>("/register/email/company", data);
const postRegisterCompanyUser = (data: IUserRegisterForm) =>
  axios.post<IGenericResponse>("/register/company", data);
const getValidateRegisterHash = (hash: string) =>
  axios.get<IGenericResponse<IRegisterValidationResponse>>("/register/validate", {
    params: { hash }
  });
const getPlans = (partnerId?: number | null) =>
  axios.get<IGenericResponse<IBasePlan[]>>("/plans", { params: { partnerId } });

export default {
  postResendEmail,
  postRegisterUser,
  postRegisterCompany,
  postRegisterCompanyUser,
  getValidateRegisterHash,
  postRegisterPassword,
  postPasswordRecovery,
  getPlans
};
